import { create } from 'zustand';

const useJoinCommunityDialogStore = create((set) => ({
  open: false,
  community: null,
  step: 'about',
  setOpen: (isOpen, community, step = 'about') =>
    set(() => ({ open: isOpen, community: community, step: step })),
  join: () => {},
}));

export default useJoinCommunityDialogStore;
